import { useCallback, useMemo } from 'react';

import Typo from '@/components/Typography/Typo';

import S from './styled';
import type { IncrementBadgeT, NumberT } from './types';

const IncrementBadge = (props: IncrementBadgeT) => {
  const numberType: NumberT = useMemo(() => {
    if (typeof props.amount === 'number') {
      if (props.amount === 0) return 'zero';
      if (props.amount < 0) return 'negative';
      return 'positive';
    }

    return 'new';
  }, [props.amount]);

  const getOperator = useCallback(() => {
    if (numberType === 'positive') return '↑';
    if (numberType === 'negative') return '↓';
    return '';
  }, [numberType]);

  return (
    <S.IncrementBadgeWrapper
      a="center"
      j="center"
      g={2}
      amountType={numberType}
    >
      <Typo type="label0" style={{ transform: 'translateY(-1px)' }}>
        {getOperator()}
      </Typo>
      <Typo type="label3">
        {typeof props.amount === 'number'
          ? `${Math.abs(props.amount).toFixed(1)}%`
          : 'new'}
      </Typo>
    </S.IncrementBadgeWrapper>
  );
};

export default IncrementBadge;
